import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=83c575ba&scoped=true"
import script from "./Values.vue?vue&type=script&lang=js"
export * from "./Values.vue?vue&type=script&lang=js"
import style0 from "./Values.vue?vue&type=style&index=0&id=83c575ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c575ba",
  null
  
)

export default component.exports